<template>
    <article>
        <p>
            When you look at any dashboard, you are mentally evaluating whether the metrics are within their
            acceptable range of values or not.
        </p>

        <p>
            In order to automate this process, you can configure alerting rules to notify you when a metric exceeds a threshold.
            However, alerts usually have no context, so you have to manually extract issues relevant to a particular app
            from the alert stream.
        </p>

        <v-img eager max-width="600" class="ma-auto my-6" src="/static/img/docs/coroot-ce/alerting-rules.svg" />

        <p>
            Coroot turns the conventional metric analysis inside out.
            It uses a distributed system model to evaluate every inspection within an application's context.
            For instance, the <var>Network round-trip time</var> inspection checks the network latency
            between a particular app and the services it depends on.
        </p>

        <v-img eager max-width="600" class="ma-auto my-6" src="/static/img/docs/coroot-ce/coroot-app-inspections.svg" />

        <p>
            From a UI/UX perspective, each dashboard at the application level has a status which is calculated
            by checking the corresponding metrics.
        </p>

        <v-card>
            <v-img eager src="/static/img/docs/coroot-ce/audit-report.png" />
        </v-card>

        <p>
            Each inspection threshold can be easily overridden for a specific application or the entire project.
        </p>

        <v-card>
            <v-img eager src="/static/img/docs/coroot-ce/inspection-configs.png" />
        </v-card>

        <h2>Application status</h2>

        <p>
            To highlight the status of each application on the overview page, Coroot takes the worst status of the following inspections:
            <var>SLO</var>, <var>Postgres</var> and <var>Redis</var>.
        </p>

        <v-card>
            <v-img eager src="/static/img/docs/coroot-ce/app-status.png" />
        </v-card>
    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
